import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-objetivos',
  templateUrl: './objetivos.component.html',
  styleUrls: ['./objetivos.component.scss']
})
export class ObjetivosComponent implements OnInit {
  optionsmes: Array<any> = [];
  optionsYear: Array<any> = [];
  optionsSucursal: Array<any> = [];

  constructor() { }

  ngOnInit() {
        this.optionsmes = [
      { value: "1", label: "Bodega 1" },
      { value: "2", label: "Bodega 2" },
      { value: "3", label: "Bodega 3" }
    ];
    this.optionsSucursal = [
      { value: "1", label: "Sucursal 1" },
      { value: "2", label: "Sucursal 2" },
      { value: "3", label: "Sucursal 3" }
    ];
    this.optionsYear = [
      { value: "1", label: "Categoria 1" },
      { value: "2", label: "Categoria 2" },
      { value: "3", label: "Categoria 3" }
    ];
  }

}
